import { render, staticRenderFns } from "./BandejaFiltros.vue?vue&type=template&id=1f45dd00&scoped=true"
import script from "./BandejaFiltros.vue?vue&type=script&lang=js"
export * from "./BandejaFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f45dd00",
  null
  
)

export default component.exports